import { useEffect, useState } from 'react'
import { TimeEntry } from '@/services/timeTracking'

interface LiveTimerProps {
  entry: TimeEntry
  formatDuration: (seconds: number) => string
  getCurrentDuration: (entry: TimeEntry) => number
}

export default function LiveTimer({ entry, formatDuration, getCurrentDuration }: LiveTimerProps) {
  const [, setTick] = useState(0)

  useEffect(() => {
    if (!entry.endTime) {
      const interval = setInterval(() => {
        setTick(tick => tick + 1)
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [entry.endTime])

  const duration = getCurrentDuration(entry)

  return (
    <div className="text-2xl font-bold text-green-900">
      {formatDuration(duration)}
    </div>
  )
} 